<template>
  <div class="customer">
    <el-select
      class="customer-select"
      filterable
      remote
      v-model="cuotomer"
      placeholder="请输入医生姓名或者科室名称"
      value-key="id"
      multiple
      :remote-method="remoteMethod"
      :loading="loading"
      @change="doctorSelect"
      style="width: 400px;max-width: 100%;"
      ref="select"
      @hook:mounted="cancalReadOnly"
      @visible-change="cancalReadOnly"
    >
      <el-option
        class="customer-select-option"
        v-for="(option, index) in optionList"
        :key="index"
        :label="option.doctor_name"
        :value="option"
      >
        <div class="customer-select-item">
          <div>
            <span>{{ option.doctor_name }}</span>
            <span>看诊费{{ option.fee }}</span>
          </div>
          <div>
            <span>{{ option.hospital_name }}-{{ option.doctor_department_names }}-{{ option.doctor_title_name }}</span>
          </div>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import mixins from "./mixins";
import cuotomerService from "@/apis/customer/index.js";

export default {
  name: "customDoctor",
  mixins: [mixins],
  data() {
    return {
      dialogFormVisible: false,
      formLabelWidth: "80px",
      cuotomerForm: {},
      query_text: "",
      cuotomer: [],
      optionList: [],
      constantOptionList: [],
      loading: false,
      hisPatientEnums: {},
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    doctorSelect(data) {
      this.constantOptionList = []
      const addItem = data.filter(item => {
        return this.constantOptionList.every(option => option.id !== item.id);
      })
      this.constantOptionList.push(...addItem)
      this.change(data, 'customDoctor')
    },
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    remoteMethod(query) {
      const { constantOptionList } = this

      if (!query) return
      this.loading = true;
      const params = {
        doctor_name: query,
      };
      cuotomerService.hisDoctorSearch(params).then((res) => {
        if (res.length > 500) {
          this.optionList = [...res.slice(0, 500), ...constantOptionList];
        } else {
          this.optionList = [...res, ...constantOptionList];
        }
        this.loading = false;
        console.log(res);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.customer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.van-contact-card::before {
  height: 0;
}
.customer-select-option {
  // display: flex;
  justify-content: space-between;
  overflow: auto;
  height: unset;
  line-height: 20px;
  padding: 10px 20px;
  span {
    white-space: pre-line;
  }
}

.customer-select-item {
  display: flex;
  flex-direction: column;
  & > div {
    display: flex;
    justify-content: space-between;
  }
}
.question-title-cion {
  cursor: pointer;
  font-size: 20px;
  margin-left: 10px;
}
</style>
<style lang="scss">
.customer-select {
  .el-select-dropdown__item {
  }
  
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    top: 20px;
  }
</style>

